export const GRANT_FINDER_NATIONWIDE_SCOPES = ["national", "nationwide"];
export const GRANT_FINDER_INTERNATIONAL_SCOPE = "international";
